import React, { useMemo } from 'react';
import { TimelineData } from 'views/Reports/types';
import TimelineChart from 'components/TimelineChart/TimelineChart';
import { formatDateToYearMonth } from 'ns_libs/formatter';
import { LABELS } from './constants';

export interface IProps {
    data: TimelineData[];
    enableScrollView?: boolean;
    lightMode?: boolean;
}

export const DealTimelineChart: React.FC<IProps> = ({ data = [], enableScrollView = true, lightMode = false }) => {
    const formattedData = useMemo(() => data.map(item => ({
        ...item,
        startDate: formatDateToYearMonth(item.startDate) || item.startDate,
        operationStartDate: formatDateToYearMonth(item.operationStartDate),
        saleMonth: formatDateToYearMonth(item.saleMonth),
        firstStabilizedMonth: formatDateToYearMonth(item.firstStabilizedMonth) || item.firstStabilizedMonth,
        developmentStartDate: formatDateToYearMonth(item.developmentStartDate) || item.developmentStartDate,
        developmentEndDate: formatDateToYearMonth(item.developmentEndDate) || item.developmentEndDate,
    })), [data]);

    return (
        <div className="px-2 w-100">
            <TimelineChart
                data={formattedData}
                scatterXFields={[
                    { name: 'startDate', label: LABELS.startDate },
                    { name: 'operationStartDate', label: LABELS.operationStartDate },
                    { name: 'saleMonth', label: LABELS.saleMonth },
                    { name: 'firstStabilizedMonth', label: LABELS.firstStabilizedMonth },
                ]}
                barXFields={{
                    start: 'developmentStartDate',
                    end: 'developmentEndDate',
                    label: LABELS.developmentPeriod,
                }}
                enableScrollView={enableScrollView}
                yField="dealName"
                lightMode={lightMode}
            />
        </div>
    );
};
export default DealTimelineChart;
